<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="container-scroller profile-image"
     [ngStyle]="{ 'background-image': 'url(' + BgImg + ')'}">
  <div class="center-div sign-left-sm-69px">

    <div class="row">
      <form class="form col-12" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="card card-width  box-shadow3 border-card-signin border-radius-10 opacity-card borderclr-signin">
          <div class="card-header background-white padding-bottom opacity-card">


            <div class="row">
              <a class="user-image-circle-65px">
                <img [src]='logo'
                     [style.width.px]="logowidth" 
                     [style.height.px]="logoheight"
                     class="margin-left-13px">
              </a>
            </div>
            <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Customer Sign In</h4>



          </div>



          <div class="card-body background-white opacity-card wow bounceInUp">

            <div class="col-md-12 col-xs-12 login_control">




              <div class="control top-link">
                <div class="label font-size-11px">User Id<span>*</span></div>
                <div class="input-group">
                  <label class="col-12">



                    <input type="text" class="form-control border-bottom-tbl font-size-24px"
                           name="CurrentLoginRequest.UserName"
                           id="CurrentLoginRequest.UserName"
                           [(ngModel)]="CurrentLoginRequest.UserName"
                           placeholder="Email ID (User Name)" required maxlength="20" #UserName="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!UserName.valid && (UserName.dirty || UserName.touched))">(Required)</small>

                  </label>
                </div>
              </div>

              <div class="control top-link2 margin-bottom-30px">
                <div class="label font-size-11px">User Id<span>*</span></div>
                <div class="input-group">
                  <label class="col-12">



                    <input type="text" class="form-control border-bottom-tbl font-size-24px"
                           name="CurrentLoginRequest.UserName"
                           id="CurrentLoginRequest.UserName"
                           [(ngModel)]="CurrentLoginRequest.UserName"
                           placeholder="Email ID (User Name)" required maxlength="20" #UserName="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!UserName.valid && (UserName.dirty || UserName.touched))">(Required)</small>

                  </label>
                </div>
              </div>

              <div class="control">
                <div class="label font-size-11px">Reg. Mobile Number<span>*</span></div>
                <label class="col-12">


                  <input type="password" class="form-control border-bottom-tbl font-size-24px"
                         name="CurrentLoginRequest.Password"
                         id="CurrentLoginRequest.Password"
                         [(ngModel)]="CurrentLoginRequest.Password"
                         placeholder="Password" required #Password="ngModel">
                  <small class="form-text text-danger"
                         *ngIf="(!Password.valid && (Password.dirty || Password.touched))">(Required)</small>

                </label>
              </div>
              <div class="form-group last-row m-0">

              </div>



            </div>


          </div>

          <div class="card-footer opacity-card">

            <!--<a (click)="onForgotPassword()" class="float-left nav-link-hand margin-left-17px ">Forgot Password</a>-->


            <button type="submit" [disabled]="!f.valid" class="btn btn-primary nav-link-hand float-right font-size-14px margin-right-31" *ngIf='!isRequesting'>Sign In</button>
          </div>



        </div>
      </form>
    </div>
  </div>
</div>


